import { render } from "./PaymentsDocumentsStage.vue?vue&type=template&id=0ff963e3&scoped=true"
import script from "./PaymentsDocumentsStage.vue?vue&type=script&lang=js"
export * from "./PaymentsDocumentsStage.vue?vue&type=script&lang=js"

import "./PaymentsDocumentsStage.vue?vue&type=style&index=0&id=0ff963e3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff963e3"]])

export default __exports__